import Vue from 'vue'
import App from './App.vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import AmCharts from 'amcharts3'
import AmSerial from 'amcharts3/amcharts/serial'
Vue.use(Vuetify)

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js